import { defineMessages } from 'react-intl';

export const DATE_FORMAT = 'YYYY-MM-DD';

export const TYPE = {
    MOBILE: 0,
    DESKTOP: 1,
};

export const LOCALIZED_STRINGS = defineMessages({
    Today: {
        id: 'TimesGrid.Day.Today',
        defaultMessage: 'Today',
    },
    Tomorrow: {
        id: 'TimesGrid.Day.Tomorrow',
        defaultMessage: 'Tomorrow',
    },
});
